const { default: loadable, lazy } = require('@loadable/component');

export default loadable;
export { lazy };
